import Vue from "vue";
import Router from "vue-router";
import Home from "./views/home/Home.vue";
import Hot from "@/views/graphs/Hot.vue";
import New from "@/views/graphs/New.vue";
import Friends from "@/views/graphs/Friends.vue";
import SearchResult from "@/views/home/SearchResult.vue";
import Terms from "@/views/terms/Terms.vue";
import Policy from "@/views/policy/Policy.vue";
import MyPageTop from "@/views/mypage/Top.vue";
import GraphDetail from "@/views/detail/GraphDetail.vue";
import CreateGraph from "@/views/CreateGraph.vue";
import CompleteGraph from "@/views/CompleteGraph.vue";
import TwitterLoginCallback from "@/views/TwitterLoginCallback.vue";
import CreateGraphForOverwrite from "@/views/CreateGraphForOverwrite.vue";
import TwitterLogin from "@/views/TwitterLogin.vue";
import Store from "@/store.js";
import ErrorPage500 from "@/views/error/ErrorPage500.vue";
import ErrorPage404 from "@/views/error/ErrorPage404.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      children: [
        {
          path: "",
          name: "home",
          component: New
        },
        {
          path: "hot",
          name: "Hot",
          component: Hot
        },
        {
          path: "new",
          name: "New",
          component: New
        },
        {
          path: "friends",
          name: "Friends",
          component: Friends
        }
      ]
    },
    {
      path: "/search",
      name: "search-result",
      component: SearchResult
    },
    {
      path: "/terms",
      name: "terms",
      component: Terms
    },
    {
      path: "/policy",
      name: "policy",
      component: Policy
    },
    {
      path: "/mypage",
      name: "mypage",
      component: MyPageTop,
      beforeEnter(to, from, next) {
        if (Store.state.twitter_account.is_login) {
          next();
        } else {
          next({
            name: "home"
          });
        }
      }
    },
    {
      path: "/graph/:id",
      name: "detail",
      component: GraphDetail
    },
    {
      path: "/create-graph",
      name: "create",
      component: CreateGraph,
      beforeEnter(to, from, next) {
        const id = to.query.id;
        // ログインしている場合、グラフ作成画面に遷移する
        if (Store.state.twitter_account.is_login) {
          next();
        } else {
          // ログインしていない場合、ツイッターログイン画面に遷移する
          if (id) {
            next({
              name: "twitterlogin",
              query: {
                callbackTo: "create",
                callbackQuery: id
              }
            });
          } else {
            next({
              name: "twitterlogin",
              query: { callbackTo: "create" }
            });
          }
        }
        if (id) {
          if (
            from.name !== "detail" &&
            from.name !== "mypage" &&
            from.name !== "complete"
          ) {
            next({
              name: "home"
            });
          } else {
            next();
          }
        }
      }
    },
    {
      path: "/complete",
      name: "complete",
      component: CompleteGraph,
      beforeEnter(to, from, next) {
        if (from.name !== "create" && from.name !== "overwrite") {
          next({
            name: "home"
          });
        } else {
          next();
        }
      }
    },
    {
      path: "/callback",
      name: "callback",
      component: TwitterLoginCallback
    },
    {
      path: "/overwrite",
      name: "overwrite",
      component: CreateGraphForOverwrite,
      beforeEnter(to, from, next) {
        if (Store.state.twitter_account.is_login) {
          next();
        } else {
          const id = to.query.id;
          next({
            name: "twitterlogin",
            query: {
              callbackTo: "overwrite",
              callbackQuery: id
            }
          });
        }
        if (
          from.name !== "detail" &&
          from.name !== "mypage" &&
          from.name !== "complete"
        ) {
          next({
            name: "home"
          });
        } else {
          next();
        }
      }
    },
    {
      path: "/twitterlogin",
      name: "twitterlogin",
      component: TwitterLogin
    },
    {
      path: "/error/500",
      name: "error500",
      component: ErrorPage500
    },
    {
      path: "*",
      component: ErrorPage404
    }
  ]
});
